import * as fetchingApi from '@services/fetchingApi'
import { webApiBuildUrl } from '@api/utils'

export const groupsGoodByGoodWebId = (goodWebId) =>
    fetchingApi.Get(webApiBuildUrl(`api/catalog/goods/${goodWebId}/groups`))
export const getAnotherOutForms = (goodId, shipment) =>
    fetchingApi.Post(webApiBuildUrl(`api/catalog/goods/${goodId}/AnotherOutForms`), shipment)
export const getAnalogues = (goodId, shipment) =>
    fetchingApi.Post(webApiBuildUrl(`api/catalog/goods/${goodId}/analogues`), shipment)
export const getInfoList = (goodId) => fetchingApi.Get(webApiBuildUrl(`api/catalog/goods/${goodId}/infoList`))
export const getUpdatedGoods = (basketItems, shipment) =>
    fetchingApi.Post(webApiBuildUrl('api/order/basket/update'), {
        basketItems,
        shipmentState: shipment
    })
export const getGoodsByIds = (goodIds, shipment, isFilteredAvailable = true) =>
    fetchingApi.Post(webApiBuildUrl('api/catalog/goods-by-ids'), { goodIds, shipment, isFilteredAvailable })
export const getSearchUnderlineTags = async (shipment) =>
    fetchingApi.Post(webApiBuildUrl('api/catalog/searchUnderlineTags'), shipment)

// Promo
export const promotions = () => fetchingApi.Get(webApiBuildUrl('api/catalog/promotions'))

export const getPromotionsCount = () => fetchingApi.Get(webApiBuildUrl('api/catalog/promotions/count'))
export const getBanners = () => fetchingApi.Get(webApiBuildUrl('api/catalog/banners'))
export const getMobileBanners = () => fetchingApi.Get(webApiBuildUrl('api/catalog/mobile-banners'))
// Cards
export const getBonusCartsCampaign = (shipment) =>
    fetchingApi.Post(webApiBuildUrl('api/catalog/bonusCardsCampaigns'), shipment)
export const getGiftCardsCampaigns = (shipment) =>
    fetchingApi.Post(webApiBuildUrl('api/catalog/giftCardsCampaigns'), shipment)
